<script lang="ts">
	import type { ComponentType } from "svelte";

	export let href: string;
	export let icon: ComponentType;
	export let label: string;
	export let isActive: boolean = false;
	export let onClick: ((event?: MouseEvent) => void) | undefined = undefined;
	export let cssClass: string = "";

	const Icon = icon;
</script>

<a
	{href}
	on:click={(e) => onClick && onClick(e)}
	class="group flex items-center gap-3 rounded-lg p-3 transition-colors {cssClass}
    {isActive
		? 'bg-secondary/10 text-secondary hover:bg-secondary/15'
		: 'text-gray-700 hover:bg-gray-100'}"
>
	<Icon class="h-5 w-5 fill-current transition-colors" filled={isActive} />
	<span class="font-medium">{label}</span>
</a>
